module.exports = __webpack_public_path__ + "static/media/pizza-header.7774ce34.jpg";